import { Component, h, Host, Prop, Element, State } from "@stencil/core";
const baseClass = "ux-iws-e-catalog-preloader";
import waitForHydrated from "../../utils/waitForHydrated";

@Component({
    tag: "ux-iws-e-catalog-preloader",
    styleUrl: "e-catalog-preloader.scss",
    shadow: false,
})
export class AsyncModalRedirect {
    /** api url to request */
    @Prop() url: string | null = null;
    /** name of modal */
    @Prop() name: string | null = null;
    /** url of modal to open on Success */
    @Prop() successModal: string | null = null;
    /** url of modal to open on load */
    @Prop() loadingModal: string | null = null;
    /** url of modal to open on error */
    @Prop() errorModal: string | null = null;

    /** state of modal (open = true, closed = false) */
    @State() modalOpen: boolean | false;
    @Element() domNode: HTMLUxIwsECatalogPreloaderElement;
    private asyncModal: HTMLUxIwsAsyncModalElement;

    componentDidLoad() {
        this.asyncModal = this.domNode.querySelector(`ux-iws-async-modal`);
        waitForHydrated(this.asyncModal, async () => {
            this.attrObserver.observe(this.asyncModal, { attributes: true });
        });
    }

    private attrObserver: MutationObserver = new MutationObserver(() =>
        this.toggleModalState()
    );

    private parseData(data: any) {
        if (data.available === true) {
            this.openModal(this.successModal);
        } else {
            this.openModal(this.errorModal);
        }
    }

    private toggleModalState = () => {
        this.modalOpen = this.asyncModal.getAttribute("opened") !== null;
        if (this.modalOpen) {
            this.fetchData(this.url).then((response) =>
                this.parseData(response)
            );
        }
    };

    private openModal(url: string | null) {
        const modal = this.domNode.querySelector(`.ux-iws-async-modal iframe`);
        if (modal) {
            (modal as any).src = url;
        }
    }

    private fetchData = async (url: string) => {
        try {
            if (url.includes("mock-data")) {
                await new Promise((resolve) => setTimeout(resolve, 3000));
            }
            const response = await fetch(url);
            return await response.json();
        } catch (error) {
            console.warn(error);
            this.openModal(this.errorModal);
        }
    };

    render() {
        const { name, loadingModal } = this;

        return (
            <Host class={baseClass}>
                <ux-iws-async-modal
                    name={name}
                    src={loadingModal}
                ></ux-iws-async-modal>
            </Host>
        );
    }
}
